<template>
  <div class="__date-range">
    <div class="date-display">
      <q-btn-dropdown v-model="visible" color="primary" :label="rangeText" outline :size="size">
        <Controller
          :range="formattedRangeToUTC"
          :quick-range-options="quickRangeOptions"
          :min-date="minDate"
          :max-date="maxDate"
          :granularity="granularity"
          @submit="changeRange"
        />
      </q-btn-dropdown>
    </div>
  </div>
</template>

<script>
/**
 * Props
 * range: {start:2020/01/01,end:2020/01/31}
 *
 * Return
 * {start:2020/01/01,end:2020/01/31}
 **/
import moment from 'moment';
import { formatToUTC } from './lib';
import Mixin from './mixin';
import Controller from './Controller';

export default {
  name: 'DateRange',
  mixins: [Mixin],
  components: { Controller },
  props: {
    range: {
      type: Object,
      required: true,
      default: () => {
        return {};
      },
    },
    size: {
      type: String,
      default: 'medium',
    },
    quickRangeOptions: {
      type: Array,
    },
    minDate: {
      type: Date,
    },
    maxDate: {
      type: Date,
    },
    granularity: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  computed: {
    rangeText() {
      return `${this.convertDate(this.range.start)} ~ ${this.convertDate(this.range.end)}`;
    },
    formattedRangeToUTC() {
      return {
        start: formatToUTC(this.range.start),
        end: formatToUTC(this.range.end),
      };
    },
  },
  methods: {
    changeRange(range) {
      const formattingRange = range => {
        const start = moment(range.start).format('YYYY-MM-DD');
        const end = moment(range.end).format('YYYY-MM-DD');
        return { start: start, end: end };
      };

      this.$emit('change', formattingRange(range));

      this.visible = false;
    },
  },
};
</script>
<style lang="scss" scoped></style>
